export { generateCommand } from './generate.command';
